import { X } from "lucide-react";
import type React from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface BasicModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  maxWidth?: string;
  maxHeight?: string;
}

export const BasicModal: React.FC<BasicModalProps> = ({
  isOpen,
  onClose,
  children,
  maxWidth = "max-w-lg",
  maxHeight,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center border border-black/50 bg-black/40 backdrop-blur-sm"
      onClick={handleBackdropClick}
    >
      <div
        className={cn(
          "relative flex max-h-[90vh] w-full flex-col rounded-tr-xl bg-white",
          maxWidth,
          maxHeight,
        )}
      >
        <Button
          onClick={onClose}
          variant="ghost"
          className="absolute right-4 top-4 z-20 bg-white/70 backdrop-blur-sm hover:bg-white"
        >
          <X className="size-5" />
        </Button>

        <div className="flex-1 overflow-auto">{children}</div>
      </div>
    </div>
  );
};
